import React from 'react';

import styles from './ContactUsCTA.module.scss';

const {
  'contact-us-cta-container': contactUsContainerClass,
  'contact-us': contactUsClasses,
  'phone-content': phoneContentClass,
  'intercom-icon': intercomIconClass,
  phone: contactPhoneClass,
  intercom: contactIntercomClass
} = styles;

const ContactUsCTA = ({
  titleCopy = 'Our planning experts are always here to help',
  customClass
}) => {
  return (
    <div className={`${contactUsContainerClass} ${customClass}`}>
      <h5>{titleCopy}</h5>
      <div className={contactUsClasses}>
        <a href="tel:8774003297" className={phoneContentClass}>
          <div className={contactPhoneClass} />
          <p>Call Us</p>
        </a>
        <div className={`${contactIntercomClass} intercom-chat`}>
          <div className={intercomIconClass} />
          <p>Live Chat</p>
        </div>
      </div>
    </div>
  );
};

export default ContactUsCTA;
